export class AngularTableColumn {
    title: string;
    name: string;
    sort: boolean;
    filtering: {
        filterString: string;
        placeholder: string;
    }
}


// WEBPACK FOOTER //
// ./src/angular_library/models/angular-table-column.ts